<template lang="pug">
v-row(:justify="currentBanner ? 'start' : 'center'")
  v-col.pb-5(cols="12" md="6" sm="6")
    v-sheet.pa-5.pa-md-8.align-self-stretch.rounded-xl.re-cursor-pointer(@click="navigateToJournal(false)" style="height: 100%;")
      template(v-if="cashRegister.shiftOpen")
        .d-flex.justify-space-between.mb-2.mb-md-7
          p.text-body-1.text-md-h4 {{ `${$t("текущая_смена")} - №${shiftNumber}` }}
          p.text-body-1.text-md-h4.tertiary--text {{ shiftStartDateTime | moment("HH:mm - DD.MM.YYYY") }}
        .d-flex.justify-space-between.align-center
          p.text-h2.mb-0.text-md-h2.text-lg-h1.re-number-font {{ shiftRevenue | numeral('0,0.[00]') }} ₸
          v-chip.py-md-2.px-md-4.d-table.py-1(x-small color="reBackground lighten-2")
            p.text-subtitle-2.mb-0.text-md-h4 {{ `${shiftTicketNumber} ${numWord(shiftTicketNumber)}` }}
        template(v-if="cashRegister.shiftExpired")
          v-btn.mt-4.mb-2.mt-md-8.d-flex.mx-auto.text-subtitle-2.text-md-subtitle-1.rounded-lg(color="reBackground lighten-2" width="100%" @click.stop="navigateToJournal(true)")
            v-icon.mr-3(left size="20" color="red") mdi-alert-circle
            | {{ $t("необходимо_закрыть_смену") }}
      template(v-else)
        p.text-subtitle-2.text-center.text-md-h3 {{ $t("нет_открытой_смены") }}
        v-btn.mt-4.mb-2.mt-md-8.d-flex.mx-auto.text-subtitle-2.text-md-subtitle-1.rounded-lg(width="100%" color="orange" @click.stop="$router.push('/kkm')") {{ $t("открыть_новую_смену") }}

  re-flash-banners
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLocale } from '../../../i18n/index'
import billsAndCoinsMixin from '../../../mixins/billsAndCoinsMixin'
import FlashBanners from './FlashBanners.vue'

export default {
  components: {
    're-flash-banners': FlashBanners,
  },

  mixins: [billsAndCoinsMixin],

  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      currentBanner: state => state.tools.currentFlashBanner,
    }),

    locale() {
      return getLocale()
    },

    shift() {
      return this.cashRegister ? this.cashRegister.shift : null
    },

    shiftNumber() {
      if (this.shift && this.shift.open && this.shift.shiftNumber) {
        return this.shift.shiftNumber
      }
      return null
    },

    shiftRevenue() {
      if (this.shift && this.shift.open && this.shift.data.revenue) {
        return this.getNumberFromBillsAndCoins(this.shift.data.revenue.sum) * (this.shift.data.revenue.isNegative ? -1 : 1)
      }
      return null
    },

    shiftTicketNumber() {
      if (this.cashRegister && this.shift && this.shift.open && this.shift.shiftTicketNumber > 0) {
        return this.shift.shiftTicketNumber
      }
      return 0
    },

    shiftStartDateTime() {
      if (this.shift && this.shift.openTime) {
        return this.shift.openTime
      }
      return null
    },
  },

  watch: {
    $route() {
      this.handleRouteChange()
    },
  },

  mounted() {
    this.handleRouteChange()
  },

  methods: {
    ...mapActions({
      init: 'cashRegisters/init',
      setGlobalLoading: 'tools/setGlobalLoading',
      showCashRegisterSwitch: 'tools/showCashRegisterSwitch',
      showSnackbar: 'tools/showSnackbar',
      clearPositions: 'positions/clear',
      openMiniApp: 'miniapp/open',
      analyticsLogEvent: 'analytics/logEvent',
    }),

    // Ловим deeplinks
    handleRouteChange() {
      const { path, fullPath, query } = this.$route

      // Handle '/list' path
      if (path === '/list') {
        this.showCashRegisterSwitch(true)
        this.$router.push('/')
        return
      }

      // Handle '/miniapp' path with query name
      if (fullPath.startsWith('/miniapp') && query.name) {
        const { name } = query
        this.openMiniApp({ name, params: query })
        this.$router.push('/')
      }

      // Handle query switchToCashRegisterId
      if (query.switchToCashRegisterId) {
        // Выбираем кассу
        this.setGlobalLoading(true)
        this.init({ params: { cashRegisterId: query.switchToCashRegisterId } })
          .then(() => {
            this.clearPositions()
            // init молча выбирает другую кассу, если запрошенной нет в списке
            // (или она NEW) - снекбар успеха только при реальном совпадении
            if (this.cashRegister && String(this.cashRegister.id) === String(query.switchToCashRegisterId)) {
              this.showSnackbar({ message: `${this.$t('вы_переключились_на_кассу')}: ${this.cashRegister.serialNumber}` })
            }
            // Вычищаем query, чтобы watcher $route не переключал кассу повторно
            this.$router.replace({ query: {} }).catch(() => {})
          })
          .finally(() => {
            this.setGlobalLoading(false)
          })
      }
    },

    navigateToJournal(zxreport) {
      if (this.shiftNumber) {
        this.$router.push(`/shifts/${this.cashRegister.id}/${this.shiftNumber}${zxreport ? '/zxreport' : ''}`)
      }
    },

    numWord(value) {
      const words = this.locale === 'ru' ? ['чек', 'чека', 'чеков'] : ['чек', 'чек', 'чек']
      value = Math.abs(value) % 100
      const num = value % 10
      if (value > 10 && value < 20) return words[2]
      if (num > 1 && num < 5) return words[1]
      if (num === 1) return words[0]
      return words[2]
    },
  },
}
</script>
<style scoped lang="stylus">
.mdi-alert-circle::before
  background-color white
  border-radius 15px
</style>
